module.exports = __webpack_public_path__ + "img/ES-J-18.bcefea13.svg";